import {
  fetchClient
} from "./chunk-64N4INLD.mjs";
import {
  resolveCaptcha
} from "./chunk-UELQYFJ7.mjs";
import {
  ApiConfig
} from "./chunk-IITKCRXL.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-RGHW4PYM.mjs";

// src/core/wbk/auth/email.ts
import { generateMd5, getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var sendOtpToEmail = (_0) => __async(null, [_0], function* ({ locale, app_source }) {
  var _a, _b;
  try {
    const captcha = yield resolveCaptcha("send_email");
    const lang = getLocaleOnly(locale);
    const data = yield fetchClient({
      url: "/email_verification/send_email",
      options: {
        method: "POST",
        body: JSON.stringify(__spreadProps(__spreadValues({ lang }, captcha), { app_source }))
      }
    });
    if (((_a = data.status) == null ? void 0 : _a.toLowerCase()) !== "success") {
      const msg = typeof (data == null ? void 0 : data.error) === "string" ? data.error : ((_b = data == null ? void 0 : data.error) == null ? void 0 : _b.code) || (data == null ? void 0 : data.message);
      throw new Error(msg || "Something went wrong...");
    }
    return true;
  } catch (error) {
    throw new Exception({
      error,
      name: "sendOtpToEmailException",
      context: { tags: { journey: "auth" } }
    });
  }
});
var verifyEmail = (_0) => __async(null, [_0], function* ({ code, locale, app_source }) {
  var _a, _b;
  try {
    const captcha = yield resolveCaptcha("verify_email");
    const lang = getLocaleOnly(locale);
    const data = yield fetchClient({
      url: "/email_verification/verify_email",
      options: {
        method: "POST",
        body: JSON.stringify(__spreadProps(__spreadValues({ code, lang }, captcha), { app_source }))
      }
    });
    if (((_a = data.status) == null ? void 0 : _a.toLowerCase()) !== "success") {
      const msg = typeof (data == null ? void 0 : data.error) === "string" ? data.error : ((_b = data == null ? void 0 : data.error) == null ? void 0 : _b.code) || (data == null ? void 0 : data.message);
      throw new Error(msg || "Something went wrong...");
    }
    return true;
  } catch (error) {
    throw new Exception({
      error,
      name: "verifyEmailException",
      context: { tags: { journey: "auth" } }
    });
  }
});
var updateEmail = (_0) => __async(null, [_0], function* ({ email, locale, app_source }) {
  var _a;
  try {
    const captcha = yield resolveCaptcha("update_email");
    const signature = generateMd5(email);
    const lang = getLocaleOnly(locale);
    const data = yield fetchClient({
      url: "/update-email",
      options: {
        method: "POST",
        body: JSON.stringify(__spreadProps(__spreadValues({ new_email: email, lang, signature }, captcha), { app_source }))
      }
    });
    if (((_a = data.status) == null ? void 0 : _a.toLowerCase()) !== "success") {
      const msg = typeof (data == null ? void 0 : data.error) === "string" ? data.error : (data == null ? void 0 : data.message) || "Something went wrong...";
      throw new Error(msg);
    }
    return email;
  } catch (error) {
    throw new Exception({
      error,
      name: "updateEmailException",
      context: { tags: { journey: "auth" } }
    });
  }
});
var checkEmail = (_0) => __async(null, [_0], function* ({
  email,
  locale,
  app_source
}) {
  var _a, _b, _c, _d;
  try {
    const captcha = yield resolveCaptcha("check_email");
    const lang = getLocaleOnly(locale);
    const data = yield fetchClient({
      url: "/auth/check-email",
      baseUrl: (_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.authApi,
      options: {
        method: "POST",
        body: JSON.stringify(__spreadProps(__spreadValues({ email, lang }, captcha), { app_source }))
      }
    });
    if (((_c = data == null ? void 0 : data.status) == null ? void 0 : _c.toLowerCase()) === "success" && (data == null ? void 0 : data.data)) {
      return data.data;
    }
    const msg = ((_d = data == null ? void 0 : data.error) == null ? void 0 : _d.description) || "Something went wrong...";
    throw new Error(msg);
  } catch (error) {
    throw new Exception({
      error,
      name: "checkEmailException"
    });
  }
});

export {
  sendOtpToEmail,
  verifyEmail,
  updateEmail,
  checkEmail
};
//# sourceMappingURL=chunk-AKQP6RCR.mjs.map